import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-center flex flex-col h-screen justify-center" }
const _hoisted_2 = {
  key: 0,
  class: "lg:w-1/2 w-3/4 mx-auto"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mt-2 text-3xl font-semibold text-gray-900" }
const _hoisted_6 = { class: "mt-2 text-lg text-gray-500" }

import { useI18n } from "vue-i18n";
import { PropType } from "vue/dist/vue";
import plugCameraImage from "@/assets/images/plug-camera-animated.gif";
import FileInputPlanner from "@/components/planner/FileInputPlanner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NoDataYet',
  props: {
  desc: {
    type: String as PropType<string>,
    default: "err.no_data_yet",
  },
  feature: {
    type: String as PropType<string>,
  },
},
  emits: ["importPlanner"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const emit = __emit;


const uploadFile = (file: File) => {
  emit("importPlanner", file);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.feature === 'planner')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(FileInputPlanner, {
            onUpdateFile: _cache[0] || (_cache[0] = ($event: any) => (uploadFile($event)))
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _unref(plugCameraImage),
            alt: "",
            class: "mx-auto mb-3 h-32 w-32"
          }, null, 8, _hoisted_4),
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("general.no_data_yet")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)(__props.desc)), 1)
        ]))
  ]))
}
}

})